import * as React from 'react';
import Button from '../components/Button';
import Typography from '../components/Typography';
import ProductHeroLayout from './ProductHeroLayout';
import BackgroundImage from './images/gridTwin.jpg'; // Import using relative path

export default function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundColor: '#7fc7d9', // Average color of the background image.
        opacity: "0.6",
        backgroundPosition: 'center', 
        zIndex: +1        
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: 'none'}}
        src={BackgroundImage}
        alt="increase priority"
      />
      <Typography style={{ zIndex: +2 }} color="inherit" align="center" variant="h2">
        Welcome to Abraxas
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        style={{ zIndex: +2 }}
        sx={{ mb: 4, mt: { sx: 4, sm: 10 } }}
      >
        The Digital Twin Platform changing how Utilities view assets
      </Typography>
      <br/>
      <br/>
      <Button
        style={{ background: '#0d7abf', zIndex: +2  }}
        color="primary"
        variant="contained"
        size="large"
        component="a"
        href="#signup"
        sx={{ minWidth: 200 }}
      >
        Learn More
      </Button>
      <Typography variant="h5" color="inherit" sx={{ mt: 2 }} style={{ zIndex: +2 }}>
        Sign up and become an insider
      </Typography>
    </ProductHeroLayout>
  );
}
